<% if (I18n.platforms[validated_appointment_slot.visit_type_category]) { %>
  <div class="message">
    <%= I18n.platforms[validated_appointment_slot.visit_type_category][platform]["message"] %>
  </div>
<% } %>
